import Keycloak from "keycloak-js";

// Essas três variáveis são resolvidas no NAVEGADOR (é ele quem fala com o
// Keycloak, não o container do front), então usam o endereço público do
// Keycloak. Em desenvolvimento local, os defaults abaixo já batem com o
// docker-compose.yml deste projeto (realm "licinet", client "licinet-frontend").
const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || "http://localhost:8081",
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "licinet",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "licinet-frontend",
});

// ATENÇÃO — isso é só pra teste local contra um client CONFIDENCIAL (com
// "Client authentication" ligado no Keycloak, como o de homologação). O
// keycloak-js foi feito só pra clients PÚBLICOS: ele nunca manda
// client_secret na troca do código pelo token, e não tem nenhuma opção de
// configuração pra isso. Esse trecho intercepta especificamente essa
// chamada (POST .../protocol/openid-connect/token) e injeta o secret no
// corpo da requisição manualmente.
//
// Só entra em ação quando REACT_APP_KEYCLOAK_CLIENT_SECRET estiver definida
// no .env — sem ela, o comportamento é o normal (PKCE puro, sem secret).
//
// NUNCA habilite isso numa build que vai servir usuários de verdade: o
// secret fica embutido no bundle JS, visível pra qualquer um que abrir o
// DevTools do navegador. O jeito certo em produção é o client ser público
// (sem secret) e usar só PKCE — o mesmo padrão que o resto deste app já
// segue. Isso aqui existe só pra destravar teste local enquanto o client de
// homologação não é trocado pra público.
const clientSecret = process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET;
if (clientSecret) {
  console.warn(
    "[keycloak] Injetando client_secret na troca de token — uso exclusivo de teste local, nunca em produção."
  );

  // IMPORTANTE: o keycloak-js 24.0.5 NÃO usa window.fetch pra chamar o
  // endpoint de token — ele monta a chamada com um XMLHttpRequest "cru"
  // (req = new XMLHttpRequest(); req.open('POST', url); req.send(params)).
  // Foi por isso que a versão anterior deste hack (que só interceptava
  // fetch) nunca disparava: o client_secret nunca era injetado em lugar
  // nenhum, e a troca de token sempre ia sem ele — exatamente o erro
  // "unauthorized_client / Invalid client or Invalid client credentials"
  // que aparecia. Por isso interceptamos XMLHttpRequest.prototype aqui,
  // não fetch.
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__isKeycloakTokenRequest =
      typeof method === "string" &&
      method.toUpperCase() === "POST" &&
      typeof url === "string" &&
      url.includes("/protocol/openid-connect/token");
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this.__isKeycloakTokenRequest && typeof body === "string") {
      const jaTemSecret = /(^|&)client_secret=/.test(body);
      if (!jaTemSecret) {
        body = body + "&client_secret=" + encodeURIComponent(clientSecret);
        console.log(
          "[keycloak] client_secret injetado na requisição de token (XHR)."
        );
      }
    }
    return originalSend.call(this, body);
  };
}

export default keycloak;
